import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import MarkdownRenderer from '@components/MarkdownRenderer';
import BlogPostAuthorBio from '@pages/Blog/components/AuthorBio';
import ShareURLComponent from '@components/ShareURLComponent';

const PageContent = ({
  content,
  currentUrl
}: {
  content: { heading: string; content: string; order: number }[];
  currentUrl?: string;
}) => {
  const hasContent = (content || []).length > 0;
  if (!hasContent) {
    return null;
  }

  return (
    <>
      <Divider sx={{ mb: 5, mt: 5 }} />
      {content.map((section) => (
        <Box key={section.heading}>
          <Typography variant="h5" component="h2" gutterBottom>
            {section.heading}
          </Typography>
          <Box mb={2} mt={2}>
            <Typography variant="body1" gutterBottom component="div">
              <MarkdownRenderer content={section.content} />
            </Typography>
          </Box>
        </Box>
      ))}
      <Box
        sx={{
          mt: 3,
          mb: 1,
          ml: 2,
          mr: 2
        }}
      >
        <BlogPostAuthorBio />
        {currentUrl ? <ShareURLComponent url={currentUrl} /> : null}
      </Box>
    </>
  );
};

export default PageContent;
